





import React, { useState, useEffect } from "react";
import { FaBars, FaTimes, FaChevronDown, FaPhoneAlt } from "react-icons/fa";
import { Link } from "react-router-dom";
import logo from "../assets/images/logo/logo.png";

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const toggleMenu = () => setIsOpen(!isOpen);

  const navLinks = [
    { name: "Home", href: "/" },
    { name: "About Us", href: "/about-us" },
    {
      name: "Practice Areas",
      isDropdown: true,
      subLinks: [
        { name: "Civil Cases", href: "/services/civil-cases" },
        { name: "Criminal Cases", href: "/services/criminal-cases" },
        { name: "Matrimonial Cases", href: "/services/matrimonial-Cases" },
        { name: "Domestic Violence", href: "/services/domestic-violence" },
        { name: "Divorce Cases", href: "/services/divorce-cases" },
        { name: "Recovery of Money", href: "/services/recovery-of-money" },
        { name: "Partnership Matters", href: "/services/partnership-matters" },
        { name: "Property Disputes", href: "/services/property-disputes" },
        { name: "Negotiable Instrument Act Cases", href: "/services/negotiable-instrument-act-cases" },
        { name: "Environmental Matters", href: "/services/environmental-matters" },
        { name: "Bail Trial", href: "/services/bail-trial" },
        { name: "Company Related Issue", href: "/services/company-related-issue" },
        { name: "Cyber Cases", href: "/services/cyber-cases" },
      ],
    },
    { name: "Blog", href: "/blogs" },
    { name: "Contact Us", href: "/contact-us" },
  ];

  return (
    <header className="fixed top-0 left-0 w-full z-50 px-4 md:px-8 py-6">
      <div 
        className={`max-w-7xl mx-auto flex items-center justify-between transition-all duration-500 rounded-2xl border border-white/10 backdrop-blur-md ${
          scrolled ? "bg-black/90 py-3 px-6 shadow-2xl" : "bg-black/40 py-4 px-8"
        }`}
      >
        {/* Logo Section */}
        <div className="flex-shrink-0 flex items-center gap-4">
          <Link to="/" className="hover:opacity-80 transition-opacity">
            <img src={logo} alt="Logo" className="h-14 md:h-16 object-contain" />
          </Link>
          <div className="hidden lg:block h-10 w-[1px] bg-white/20 mx-2"></div>
          <div className="hidden lg:block">
            <p className="text-[10px] uppercase tracking-[0.3em] text-[#C8A27C] font-bold leading-tight">
              Saurav Dagar
            </p>
            <p className="text-[9px] uppercase tracking-[0.2em] text-white/60">Advocate</p>
          </div>
        </div>

        {/* Desktop Navigation */}
        <nav className="hidden xl:flex items-center gap-10">
          {navLinks.map((link) => (
            <div key={link.name} className="relative group">
              {link.isDropdown ? (
                <button className="flex items-center gap-1.5 text-[12px] font-bold tracking-widest uppercase text-white hover:text-[#C8A27C] transition-all">
                  {link.name}
                  <FaChevronDown size={10} className="group-hover:rotate-180 transition-transform duration-300" />
                  <span className="absolute -bottom-1 left-0 w-0 h-[1px] bg-[#C8A27C] transition-all group-hover:w-full"></span>
                </button>
              ) : (
                <Link
                  to={link.href}
                  className="relative text-[12px] font-bold tracking-widest uppercase text-white hover:text-[#C8A27C] transition-all group"
                >
                  {link.name}
                  <span className="absolute -bottom-1 left-0 w-0 h-[1px] bg-[#C8A27C] transition-all group-hover:w-full"></span>
                </Link>
              )}

              {/* Enhanced Dropdown Menu */}
              {link.isDropdown && (
                <div className="absolute top-full left-1/2 -translate-x-1/2 pt-6 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-300">
                  <div className="w-80 rounded-xl border border-white/10 bg-black/95 backdrop-blur-xl shadow-[0_20px_50px_rgba(0,0,0,0.5)] overflow-hidden">
                    <div className="max-h-[500px] overflow-y-auto py-4 px-2 space-y-1">
                      {link.subLinks.map((sub) => (
                        <Link
                          key={sub.name}
                          to={sub.href}
                          className="block px-6 py-3 text-[11px] uppercase tracking-wider text-gray-400 hover:text-[#C8A27C] hover:bg-white/5 rounded-lg transition-all"
                        >
                          {sub.name}
                        </Link>
                      ))}
                    </div>
                  </div>
                </div>
              )}
            </div>
          ))}
        </nav>

        {/* Action Button */}
        <div className="flex items-center gap-4">
          <Link 
            to="/contact-us" 
            className="hidden md:block px-6 py-2.5 border border-[#C8A27C] text-[#C8A27C] text-[11px] uppercase tracking-widest hover:bg-[#C8A27C] hover:text-black transition-all duration-500 font-black rounded-lg"
          >
            Free Consultation
          </Link>
          <button className="xl:hidden text-white hover:text-[#C8A27C] transition-colors" onClick={toggleMenu}>
            {isOpen ? <FaTimes size={24} /> : <FaBars size={24} />}
          </button>
        </div>
      </div>

      {/* Mobile Sidebar Navigation */}
      <div className={`fixed inset-0 bg-black/95 z-[60] xl:hidden transition-transform duration-500 ${isOpen ? "translate-x-0" : "translate-x-full"}`}>
        <div className="flex flex-col h-full p-10">
          <div className="flex justify-between items-center mb-12">
            <img src={logo} alt="Logo" className="h-12 object-contain" />
            <button onClick={toggleMenu} className="text-white"><FaTimes size={30} /></button>
          </div>
          <div className="space-y-6 overflow-y-auto">
            {navLinks.map((link) => (
              <div key={link.name} className="border-b border-white/10 pb-4">
                {link.isDropdown ? (
                  <details className="group text-white">
                    <summary className="list-none flex justify-between items-center uppercase text-xl font-bold tracking-tighter">
                      {link.name} <FaChevronDown size={14} className="group-open:rotate-180 transition-transform" />
                    </summary>
                    <div className="mt-4 grid grid-cols-1 gap-3 pl-4">
                      {link.subLinks.map((sub) => (
                        <Link key={sub.name} to={sub.href} className="text-gray-400 text-sm hover:text-[#C8A27C]" onClick={toggleMenu}>
                          {sub.name}
                        </Link>
                      ))}
                    </div>
                  </details>
                ) : (
                  <Link to={link.href} className="block text-white uppercase text-xl font-bold tracking-tighter hover:text-[#C8A27C]" onClick={toggleMenu}>
                    {link.name}
                  </Link>
                )}
              </div>
            ))}
          </div>
          <div className="mt-auto pt-10">
             <a href="tel:+123456789" className="flex items-center justify-center gap-3 w-full py-5 bg-[#C8A27C] text-black font-black uppercase tracking-widest rounded-xl">
               <FaPhoneAlt /> Urgent Consultation
             </a>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;